import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./Pages/LandingPage";
import ImpactPage from "./Pages/ImpactPage";
import DemoTravelOffset from "./Pages/DemoTravelOffset";

function App() {
  const merchantCode = 'AASMARTFUEL';  //BES_NZ_AA_NEW_ZEALAND
  const [fetchedImpact, setfetchedImpact] = useState();
  const [projects, setProjects] = useState();

  useEffect(() => {

    if (!location?.pathname.includes('impact')) { // fetch impact projects
      project.projects(null, merchantCode, null)
        .then(response => response.json())
        .then(body => setProjects(body))
        .catch(error => {
          setProjects(error);
        })
    }

    impact.merchants(merchantCode, null, ['flightsImpact']) // fetch flight impact
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        setfetchedImpact(error)
      })
  }, []);

  return (
    <>

      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-aa-nz-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/demo-travel-offset`}
          key="demo-travel-offset"
        >
          <DemoTravelOffset  />
        </Route>
        <Route
          path={`/`}
          key="app-aa-nz-landing"
        >
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>

    </>
  );
}

export default App;
